export default "__VITE_ASSET__CftHEmMv__"